module.exports = __webpack_public_path__ + "img/shadow_android_zh.529575c.png";